import Vue from 'vue'
import Vuex from 'vuex'

import { core, CoreModule } from './modules/core'

Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {
    core
  },
  strict: false
})

export const vxm = {
  core: CoreModule.CreateProxy(store, CoreModule) as CoreModule
}
